import React from 'react';
import { ImageFile } from '~/data/types/images';

const FamilyCarPromoIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      width="1009"
      height="328"
      viewBox="0 0 1009 328"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24748 193.16C549.124 190.45 179.124 191.811 264.6 193.303M1002.66 193.166C908.828 179.948 532.725 184.906 264.6 193.303M264.6 193.303C274.799 149.34 346.884 70.0797 384.297 109.276C427.669 154.716 297.914 192.26 264.6 193.303ZM264.6 193.303C264.475 195.738 264.721 190.868 264.6 193.303ZM264.6 193.303C264.838 188.7 265.086 184.1 265.341 179.505C265.616 174.635 211.006 54.2571 166.749 105.479C142.404 133.657 189.855 175.75 264.6 193.303ZM264.6 193.303C264.507 195.197 264.691 191.409 264.6 193.303ZM264.6 193.303C278.588 244.729 388.578 232.026 371.035 317.023M264.6 193.303C239.383 204.778 174.043 239.655 198.739 296.955"
        stroke="#00D6D1"
        stroke-width="11.3075"
        stroke-linecap="round"
      />
      <path
        d="M159.16 3.39062C157.707 17.1562 150.371 44.6874 132.648 44.6874"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M159.159 74.6797C160.816 63.5114 169.184 41.1748 189.398 41.1748"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M159.159 3C160.816 15.7267 169.184 41.18 189.398 41.18"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M159.16 74.6797C157.707 64.6802 150.371 44.6811 132.648 44.6811"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M111.03 102.338C108.233 101.341 101.72 86.7672 99.9732 88.7264C98.2265 90.6856 96.2988 103.342 94.548 103.461C92.7972 103.58 75.7112 100.293 76.7215 101.767C77.7318 103.242 91.6301 112.267 91.7268 114.576C91.8235 116.884 87.0462 129.556 88.797 129.437C90.5479 129.318 101.475 117.888 103.838 117.846C106.201 117.804 121.492 128.574 122.546 127.137C123.601 125.7 115.265 114.634 115.876 112.93C116.488 111.226 131.239 98.0521 129.005 98.2044C126.772 98.3566 113.827 103.334 111.03 102.338Z"
        stroke="#00D6D1"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M106.011 258.55L126.45 227.917C134.725 228.658 139.968 228.471 144.779 227.067C145.903 226.739 146.881 228.043 146.212 229.004L135.289 244.707C134.735 245.502 135.304 246.591 136.273 246.591H156.056C157.189 246.591 157.69 248.017 156.807 248.726L113.819 284.656C112.762 285.504 111.33 284.222 112.056 283.077L124.768 263.039C125.263 262.259 124.729 261.237 123.806 261.198L106.909 260.484C105.936 260.442 105.415 259.32 106.011 258.55Z"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M441.886 107.836C440.816 118.16 435.41 138.809 422.352 138.809"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M441.89 161.305C443.111 152.928 449.277 136.176 464.172 136.176"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M441.89 107.539C443.111 117.084 449.277 136.174 464.172 136.174"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
      <path
        d="M441.886 161.305C440.816 153.805 435.41 138.806 422.352 138.806"
        stroke="#FFE500"
        stroke-width="4.52301"
        stroke-linecap="round"
      />
    </Component>
  );
};

export default FamilyCarPromoIcon;
